/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "F:/zhaoyanning/\u627F\u5FB7\u5E02\u653F\u5E9C-\u5BF9\u63A5\u94F6\u884C/mobile-master/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Application',
  components: {},
  data: function data() {
    return {
      navData: [],
      dian: false,
      mi: '',
      ha: false,
      nav: 0,
      navs: 0,
      xiaci: false,
      //又一次下一次
      navshow: false //新手引导

    };
  },
  computed: {},
  watch: {
    navData: function navData() {
      this.$nextTick(function () {
        if (this.nav == 1) {
          this.ha = true;
          this.navshow = true;
          this.navs = this.$utils.Store.getItem('navs') ? this.$utils.Store.getItem('navs') : 0;
          this.noviceGuidances();
        }
      });
    }
  },
  methods: {
    //新手引导(多级审批)
    noviceGuidances: function noviceGuidances() {
      if (!this.ha) {
        return;
      }

      if (this.navs == 1) {
        this.navshow = true;
        this.mi = 'navss';
      } else {
        if (this.dian) {
          this.navshow = true;
          this.mi = '/leaveDetails';
          this.xiaci = true;
        } else {
          this.mi = '/multistageApproval';
        }
      }

      var bootModule = document.getElementById(this.mi);
      var Itemtop = bootModule.getBoundingClientRect().bottom; //获取dom对象底边与顶部距离

      var Itemwidth = bootModule.offsetWidth;
      var Itemheight = bootModule.offsetHeight;
      var GuideBox = document.getElementById('IndexGuideBox'); //获取蒙版dom对象

      var navBoxTop = document.getElementsByClassName('navBoxTop'); //获取小圆圈以及竖线 外边的dom对象

      if (this.navs == 1) {
        GuideBox.style.top = parseInt(Itemtop, 10) + 'px';
      } else {
        bootModule.style.background = 'transparent'; //高亮背景颜色
      }

      bootModule.style.zIndex = '502';
      bootModule.style.border = '1px dashed #fff';
      bootModule.style.padding = '0.04rem';
      bootModule.style.borderRadius = ' 0.06rem';
      navBoxTop[0].style.left = parseInt(Itemwidth / 2, 10) + 'px';

      if (this.dian) {
        GuideBox.style.marginTop = -parseInt(Itemheight, 10) + 'px';
      }
    },
    cancelNav: function cancelNav() {
      this.navshow = false;
      this.ha = false;
      this.mi = false;
      this.$utils.Store.setItem('firstLogin', 0);
      this.$utils.Store.setItem('nav', 0);
      this.$utils.Store.setItem('navs', 0);
      this.$router.push({
        path: '/'
      });
    },
    // 我知道了
    know: function know() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.navshow = false;
                _this.ha = false;
                _this.mi = '';
                _context.next = 5;
                return _this.clearDom('navss');

              case 5:
                _this.$utils.Store.setItem('firstLogin', 0);

                _this.$utils.Store.setItem('nav', 0);

                _this.$utils.Store.setItem('navs', 0);

                _this.$router.push({
                  path: '/'
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 再来一次
    aginlai: function aginlai() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.navshow = false;
                _this2.ha = false;
                _this2.mi = false;
                _context2.next = 5;
                return _this2.clearDom('navss');

              case 5:
                _this2.$utils.Store.setItem('firstLogin', 1);

                _this2.$utils.Store.setItem('nav', 1);

                _this2.$utils.Store.setItem('navs', 0);

                _this2.$router.push({
                  path: '/'
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    //下一步
    nextNav: function nextNav() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.xiaci) {
                  _context3.next = 7;
                  break;
                }

                _this3.navshow = false;
                _this3.ha = false;
                _this3.mi = false;

                _this3.$utils.Store.setItem('nav', 1);

                _this3.$router.push({
                  path: '/leaveDetails'
                });

                return _context3.abrupt("return");

              case 7:
                _this3.$utils.Store.setItem('nav', 1);

                _this3.navshow = false;
                _this3.dian = true;
                _context3.next = 12;
                return _this3.clearDom(_this3.mi);

              case 12:
                _this3.noviceGuidances('/leaveDetails');

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    //结束引导以及 我知道了
    clearDom: function clearDom(val) {
      var bootModule = document.getElementById(val); //  制作边框

      if (val != 'navss') {
        bootModule.style.background = 'white'; //高亮背景颜色
      }

      bootModule.style.zIndex = 'auto'; //蒙版是501  高出蒙版就可以显示蒙版上层

      bootModule.style.border = 'none'; //添加边框

      bootModule.style.padding = '0rem'; //边框与内容有个内边距

      bootModule.style.borderRadius = ' 0'; //边框圆角弧度
    },
    ifback: function ifback() {
      if (this.nav == 1) {
        if (window.history && window.history.pushState) {
          if (this.$route.query.nav == 1) {
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', function () {
              history.pushState(null, null, document.URL);
            }, false);
          }
        }
      } else {
        if (window.history && window.history.pushState) {
          history.pushState(null, null, document.URL);
          window.addEventListener('popstate', this.back, false);
        }
      }
    },
    back: function back() {
      this.$router.push({
        path: '/'
      });
    },
    getHomeMenu: function getHomeMenu() {
      var _this4 = this;

      //获取菜单
      this.$utils.Tools.loadShow();
      this.$api.Home.getHomeMenu({
        companyId: 0,
        userId: this.$utils.Store.getItem('userSerial'),
        spareCol2: 1
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this4.$code.success) {
          _this4.$utils.Tools.loadHide();

          _this4.$utils.Tools.toastShow(msg);
        } else {
          _this4.navData = data;

          _this4.$utils.Store.setLocalItem('menuApp', JSON.stringify(data));

          _this4.$utils.Tools.loadHide();
        }
      }).catch(function () {
        _this4.$utils.Tools.httpError();
      });
    },
    navClick: function navClick(value) {
      //列表的点击事件
      if (value === '' || value === null) {
        this.$utils.Tools.toastShow('功能暂未开放');
      } else {
        this.$router.push(value);
      }
    },
    getUserPower: function () {
      var _getUserPower = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response, code, msg, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                //暂时不知道--
                this.$utils.Tools.loadShow();
                _context4.next = 3;
                return this.$api.UserPower.selectByPrimaryKey(this.$utils.Store.getItem('userSerial'));

              case 3:
                response = _context4.sent;
                this.$utils.Tools.loadHide();
                code = response.code, msg = response.msg, data = response.data;

                if (+code !== this.$code.success) {
                  this.$utils.Tools.toastShow(msg);
                } else {
                  if (data) {
                    this.$params.setApprove(data.userType + '');
                    this.$params.setCopyuser(data.userType + '');
                  }
                }

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getUserPower() {
        return _getUserPower.apply(this, arguments);
      }

      return getUserPower;
    }()
  },
  created: function created() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this5.nav = _this5.$utils.Store.getItem('nav') ? _this5.$utils.Store.getItem('nav') : 0;
              _this5.navs = _this5.$utils.Store.getItem('navs') ? _this5.$utils.Store.getItem('navs') : 0;

              if (!(_this5.$params.appcopy === '1')) {
                _context5.next = 5;
                break;
              }

              _context5.next = 5;
              return _this5.getUserPower();

            case 5:
              _this5.navData = JSON.parse(_this5.$utils.Store.getLocalItem('menuApp'));

              _this5.getHomeMenu();

              _this5.$utils.Store.removeItem('bh');

              _this5.$utils.Store.removeItem('oldVal');

              _this5.$utils.Store.removeItem('approver');

              _this5.$utils.Store.removeItem('copyer');

              _this5.$utils.Store.removeItem('customer');

              _this5.$utils.Store.removeItem('henchman');

              _this5.$utils.Store.removeItem('imgList');

              _this5.$utils.Store.removeItem('applyItem');

              _this5.$utils.Store.removeItem('applyLx');

              _this5.$utils.Store.removeItem('approvalItem');

              _this5.$utils.Store.removeItem('approvalLx');

            case 18:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  mounted: function mounted() {
    this.ifback();
  },
  destroyed: function destroyed() {
    window.removeEventListener('popstate', this.back, false); //false阻止默认事件
  }
};